import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Center_Performance_1.css';
import { Link } from 'react-router-dom';

const MIN_SPEED = 1.5;
const MAX_SPEED = 2.5;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}

const CenterStage1 = () => {
  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();

    // Cleanup function if needed
    // return () => { cleanup };
  }, []);

  return (
    <div className="schedule-container">
      <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>
    

<div className="base-box">
    {/*시각*/}
   
      <Helmet>
       <link rel="preconnect" href="https://fonts.googleapis.com" />
       <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
       <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jua&display=swap" rel="stylesheet" />
      </Helmet>
     <div className="time-block_Oclock">18:00</div>
     <div className="time-block">18:10</div>
     <div className="time-block">18:20</div>
     <div className="time-block">18:30</div>
     <div className="time-block">18:40</div>
     <div className="time-block">18:50</div>
     <div className="time-block_Oclock">19:00</div>           
     <div className="time-block">19:10</div>
     <div className="time-block">19:20</div>
     <div className="time-block">19:30</div>
     <div className="time-block">19:40</div>
     <div className="time-block">19:50</div>
     <div className="time-block_Oclock">20:00</div>
     <div className="time-block">20:10</div>
     <div className="time-block">20:20</div>
     <div className="time-block">20:30</div>
     <div className="time-block">20:40</div>
     <div className="time-block">20:50</div>
    {/*공연순서*/}
   
     <Helmet>
       <link rel="preconnect" href="https://fonts.googleapis.com" />
       <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
       <link href="https://fonts.googleapis.com/css2?family=Jua&display=swap" rel="stylesheet" />
     </Helmet>
     <div className='posi'>
     <div className="list-box_opening">오프닝</div>
     <div className="list-box_15m_purple">Zenprix</div>
     <div className="list-box_10m_white">더블에이치</div>
     <div className="list-box_10m_purple">Allure</div>
     <div className="list-box_10m_white">unofficial club</div>
     <div className="list-box_10m_purple">SEASONS</div>
     <div className="list-box_15m_white">장수돌침대</div>
     <div className="list-box_10m_purple">라드훅</div>
     <div className="list-box_15m_white">성심극연</div>
     <div className="list-box_spacer"></div>{/*간격조정*/}
     <div className="list-box_15m_purple">학군단_하계</div>
     <div className="list-box_15m_white">더버스킹</div>
     <div className="list-box_15m_purple">세이크리드</div>
     <div className="list-box_15m_white">밴드실험</div>
     </div>
    {/*시간선*/}
    

  </div>
   <Helmet>
       <link rel="preconnect" href="https://fonts.googleapis.com" />
       <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
       <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jua&display=swap" rel="stylesheet" />
   </Helmet>
  <Link to="/Performance">
    <button className="nav-button-white">BACK</button>
  </Link>
  <Link to="/centerstage2">
    <button  className="nav-button-white-2">DAY 2</button>
  </Link>

</div>
    
  );
}

export default CenterStage1;
